async function checkout() {
    const btn = document.querySelectorAll('.cart__checkout-button.button');

    if (btn.length) {
        btn.forEach(e => {
            e.addEventListener("click", function() {
                // Disable button ngay khi click
                e.disabled = true;
                e.innerText = "Loading...";

                // Giả lập xử lý (ví dụ gọi API)
                setTimeout(() => {
                    e.disabled = false;
                    e.innerText = "Submit";
                }, 3000);
            });

        });
    }
}

document.addEventListener("DOMContentLoaded", function() {
    checkout();

    let quickAddDrawer = document.querySelector('#cart-drawer');

    if (quickAddDrawer) {
        let observer = new MutationObserver(function(mutations) {
            mutations.forEach(function(m) {
                if (m.addedNodes.length) {

                    checkout()
                    if (typeof BSS_B2B == 'object') {
                        BSS_B2B.observer.cartSubject.listenCartCheckout()
                    }

                }
            });
        });

        observer.observe(quickAddDrawer, {
            childList: true,
        });
    }



    const isPDP = window.location.pathname.includes("/products/");
    if (isPDP) {
        let oldHref = location.href;
        new MutationObserver(() => {
            if (oldHref !== location.href) {
                oldHref = location.href;
                const variant = new URL(location.href).searchParams.get('variant');
                let a = document.querySelector('.tz-main-price-wrapper[bss-b2b-variant-price]')
                if (a) {
                    a.classList.add('bss-disable')
                }
                setTimeout(() => {
                    const productForm = document.querySelector("[bss-b2b-main-product-form]");
                    BSS_B2B.observer.productSubject.notifyObserver('VariantChange', 'VariantSelectChange', {
                        productForm
                    });
                      a.classList.remove('bss-disable')
                }, 1200)
            }
        }).observe(document, {
            subtree: true,
            childList: true
        });
    }
});